<script setup>
import { homeData } from '@/graphql/queries/homepage.js'

definePageMeta({
  layout: 'default',
})

const { locale } = useI18n()

const variables = computed(() => ({
  locale: locale.value,
}))

const { data } = await useGraphql(homeData, variables)

if (!data.value.home) {
  throw createError({ statusCode: 404 })
}

const page = computed(() => data?.value.home)
const allNotiziaPages = computed(() => data?.value.allNotiziaPages || [])

const seo = computed(() => page?.value.seo || {})
useSeo(seo)
</script>

<template>
  <div class="page homepage">
    <LazyPagineHomeHero :hero="page.hero" />
    <LazyDoubleBlockCards :block="page.intro" />
    <LazyTripleBlock :block="page.sezioneServizi" />
    <LazySwiperSlider
      v-if="
        page.carosello && page.carosello.slide && page.carosello.slide.length
      "
      :slides="page.carosello.slide"
      type="offset-type"
      class="p-top-xxl-1"
      :is-home="true"
    />
    <LazyTitleText
      class="row-400-25"
      :block="page.sezioneTitoloTesto"
      :max-content="true"
    />
    <LazyImgText
      :block="page.sezioneImmagineTesto1"
      :type="page.sezioneImmagineTesto1.immagineADestra ? 'reverse' : 'default'"
      :max-content="true"
      image-shape="capsule"
    />
    <LazySwiperSlider
      v-if="allNotiziaPages && allNotiziaPages.length"
      :slides="allNotiziaPages.map((notizia) => notizia)"
      type="default-type"
      class="p-top-xxl-1"
    />
    <LazyImgText
      class="p-bottom-m-1"
      :block="page.sezioneImmagineTesto2"
      :type="page.sezioneImmagineTesto2.immagineADestra ? 'reverse' : 'default'"
      image-shape="arch-shape"
    />
  </div>
</template>
